import {
  createContext,
  PropsWithChildren,
  ReactNode,
  useCallback,
  useRef,
  useState,
} from 'react'

export const ClockOffsetContext = createContext<number>(0)
export const AddClockSampleContext = createContext<
  (serverTime: number) => void
>(() => {})

// Weight applied to each new sample in the EWMA. At α=0.2, convergence is
// rapid relative to the number of push updates a match generates.
const ALPHA = 0.2

export const ClockSyncProvider = ({
  children,
}: PropsWithChildren): ReactNode => {
  const [offset, setOffset] = useState<number>(0)
  const initialized = useRef(false)

  const addSample = useCallback((serverTime: number) => {
    const sample = serverTime - Date.now()
    setOffset((prev) => {
      if (!initialized.current) {
        initialized.current = true
        return sample
      }
      return prev * (1 - ALPHA) + sample * ALPHA
    })
  }, [])

  return (
    <ClockOffsetContext.Provider value={offset}>
      <AddClockSampleContext.Provider value={addSample}>
        {children}
      </AddClockSampleContext.Provider>
    </ClockOffsetContext.Provider>
  )
}
